module.exports = __webpack_public_path__ + "static/media/javascript.2b5f0076.png";